import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { ACCREDITED_ESTABLISHMENTS_SPECIALTIES_FILTER } from '@/global/constants/reactQueryKeys'
import {
  GetFilterResponse,
  getSpecialtiesFilterOptions
} from '@/modules/accredited-establishments/api'
import { addError } from '@/global/plugins/observability'
import {
  AccreditedEstablishmentsCode,
  Context
} from '@/global/plugins/observability/observability.constants'
import { ApiErrorResponse } from '@/global/api/types'
import { AxiosError } from 'axios'
import { toastApiError } from '@/global/utils/toastApiError/toastApiError'

export const useGetSpecialtiesFilter = () => {
  const result = useQuery<GetFilterResponse, AxiosError<ApiErrorResponse>>({
    queryKey: ACCREDITED_ESTABLISHMENTS_SPECIALTIES_FILTER,
    queryFn: getSpecialtiesFilterOptions,
    select: data => ({
      ...data,
      ...{
        items: [
          { title: 'Todas as especialidades', value: 'ALL' },
          ...data.items
        ]
      }
    })
  })

  const { error } = result

  useEffect(() => {
    if (error) {
      const data = {
        context: Context.ACCREDITED_ESTABLISHMENTS,
        code: AccreditedEstablishmentsCode.GET_SPECIALTIES_FILTER_OPTIONS_ERROR,
        message: 'Erro ao obter as especialidades'
      }
      addError({ error, data })

      toastApiError({ status: error.response?.status })
    }
  }, [error])

  return result
}
